import React, {useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useSelector} from 'react-redux';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import {faUser} from '@fortawesome/pro-light-svg-icons';
import {faBars} from '@fortawesome/pro-regular-svg-icons';

import MenuDrawer from './MenuDrawer';
import ProfileMenuDrawer from './ProfileMenuDrawer';
import {selectUserGroup} from '../../redux/slices/user';

import baseStyles from '../../css/Base.module.css';

export default function PrimaryAppBar() {
  const [isMenuOpen, toggleMenu] = useState(false);
  const [isProfileMenuOpen, toggleProfileMenu] = useState(false);

  const userGroup = useSelector(selectUserGroup);
  const hasLogo = !!userGroup?.logoURL;

  return (
    <>
      <MenuDrawer isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />
      <ProfileMenuDrawer isMenuOpen={isProfileMenuOpen} toggleMenu={toggleProfileMenu} />
      <div className={baseStyles['f-g-1']}>
        <AppBar position="sticky" className="bg-brandorange">
          <Toolbar variant="dense">
            <IconButton
              edge="start"
              className="m-r-15"
              color="inherit"
              aria-label="menu"
              onClick={() => toggleMenu(!isMenuOpen)}
              size="large"
            >
              <FontAwesomeIcon icon={faBars} size="xs" />
            </IconButton>
            <Typography variant="h6" className={baseStyles['f-g-1']}>
              Flamingo Learning
            </Typography>

            <div className="p-tb-5">
              {hasLogo ? (
                <Avatar
                  src={userGroup?.logoURL}
                  onClick={() => toggleProfileMenu(!isProfileMenuOpen)}
                  className={baseStyles['cursor-pointer']}
                  sx={{height: 45, width: 45}}
                >
                  <FontAwesomeIcon icon={faUser} className="clr-gray-200" size="xs" />
                </Avatar>
              ) : (
                <IconButton onClick={() => toggleProfileMenu(!isProfileMenuOpen)} size="large">
                  <FontAwesomeIcon icon={faUser} className="clr-gray-200" size="xs" />
                </IconButton>
              )}
            </div>
          </Toolbar>
        </AppBar>
      </div>
    </>
  );
}
